export const EDIT = 'edit';
export const READ = 'read';
export const CREATE = 'create';
